module.exports = __webpack_public_path__ + "static/media/sitioEnConstruccion.88d71683.svg";